import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'
import _imports_1 from '../assets/images/logout.png'
import _imports_2 from '../assets//images/avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-460e286e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homepage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar",
  src: _imports_2
}, null, -1))
const _hoisted_4 = { class: "username" }
const _hoisted_5 = { class: "centralarea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_HomeMenu = _resolveComponent("HomeMenu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { style: {"width":"100%","height":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, {
          style: _normalizeStyle({
          background: 'linear-gradient(135deg,#1c319e,#d39d38,#4da0b0)',
          padding: 0,
        })
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("img", {
              src: _imports_1,
              class: "head",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
            }),
            _createVNode(_component_a_select, {
              class: "select",
              value: _ctx.lanValue,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lanValue) = $event)),
              bordered: false,
              onChange: _ctx.handleChangeLan,
              options: _ctx.options
            }, {
              suffixIcon: _withCtx(() => []),
              _: 1
            }, 8, ["value", "onChange", "options"]),
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.userName), 1)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              breakpoint: "lg",
              "collapsed-width": "0",
              class: "menu"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_HomeMenu)
              ]),
              _: 1
            }),
            _createVNode(_component_a_modal, {
              open: _ctx.open,
              "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.open) = $event)),
              title: _ctx.t('exitprompt'),
              onOk: _ctx.handleOk
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.t("logout")), 1)
              ]),
              _: 1
            }, 8, ["open", "title", "onOk"]),
            _createVNode(_component_a_layout_content, { class: "content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}